var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarGold1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "star-gold-1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.254,
    height: 37.671,
    viewBox: "0 0 39.254 37.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fedb4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb11a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M21.3,1.916,25.2,9.831a2.369,2.369,0,0,0,1.784,1.3L35.722,12.4a2.369,2.369,0,0,1,1.313,4.041L30.715,22.6a2.37,2.37,0,0,0-.681,2.1l1.492,8.7a2.369,2.369,0,0,1-3.437,2.5l-7.812-4.108a2.369,2.369,0,0,0-2.2,0L10.26,35.9a2.369,2.369,0,0,1-3.437-2.5l1.492-8.7a2.37,2.37,0,0,0-.681-2.1l-6.32-6.162A2.369,2.369,0,0,1,2.626,12.4l8.734-1.269a2.369,2.369,0,0,0,1.784-1.3L17.05,1.916a2.369,2.369,0,0,1,4.249,0Z",
    transform: "translate(-0.595 -0.595)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.418,
    y1: 1.461,
    x2: 0.418,
    y2: 0.408,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M21.3,1.916,25.2,9.831a2.369,2.369,0,0,0,1.784,1.3L35.722,12.4a2.369,2.369,0,0,1,1.313,4.041L30.715,22.6a2.37,2.37,0,0,0-.681,2.1l1.492,8.7a2.369,2.369,0,0,1-3.437,2.5l-7.812-4.108a2.369,2.369,0,0,0-2.2,0L10.26,35.9a2.369,2.369,0,0,1-3.437-2.5l1.492-8.7a2.37,2.37,0,0,0-.681-2.1l-6.32-6.162A2.369,2.369,0,0,1,2.626,12.4l8.734-1.269a2.369,2.369,0,0,0,1.784-1.3L17.05,1.916a2.369,2.369,0,0,1,4.249,0Z",
    transform: "translate(0.452 0.452)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M9.643,37.671A3.483,3.483,0,0,1,6.22,33.6l1.487-8.668a1.247,1.247,0,0,0-.359-1.1L1.052,17.7a3.477,3.477,0,0,1,1.927-5.929l8.7-1.264a1.241,1.241,0,0,0,.937-.68l3.892-7.886A3.454,3.454,0,0,1,19.627,0h0a3.453,3.453,0,0,1,3.116,1.937l3.892,7.886a1.244,1.244,0,0,0,.937.68l8.7,1.264A3.476,3.476,0,0,1,38.2,17.7l-6.3,6.138a1.246,1.246,0,0,0-.359,1.1L33.033,33.6a3.475,3.475,0,0,1-5.043,3.663l-7.784-4.091a1.245,1.245,0,0,0-1.158,0l-7.783,4.093a3.485,3.485,0,0,1-1.621.4ZM19.627,2.23a1.222,1.222,0,0,0-1.116.694L14.619,10.81A3.473,3.473,0,0,1,12,12.712L3.3,13.976a1.245,1.245,0,0,0-.69,2.122l6.3,6.138a3.479,3.479,0,0,1,1,3.076L8.419,33.981a1.245,1.245,0,0,0,1.806,1.312L18.009,31.2a3.472,3.472,0,0,1,3.235,0l7.784,4.091a1.244,1.244,0,0,0,1.805-1.311l-1.487-8.668a3.477,3.477,0,0,1,1-3.076l6.3-6.139a1.245,1.245,0,0,0-.69-2.122l-8.7-1.264a3.477,3.477,0,0,1-2.617-1.9L20.742,2.924a1.222,1.222,0,0,0-1.115-.694h0Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 2.167,
    cy: 0.687,
    rx: 2.167,
    ry: 0.687,
    transform: "translate(16.809 7.338) rotate(-66.153)",
    fill: "#fff",
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(1.047 1.047)",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M37.123.182S20.081,21.16,3.564,24.962,8.021,48.431,8.676,48.431s36.443-3.147,36.443-3.147L57.7,23.126,53.771,4.9Z",
    transform: "translate(-3.555 -0.959)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M43.122,3.169S22.991,21.2,6.081,22.356s.708,23.878,1.355,23.981S43.92,48.968,43.92,48.968l15.915-19.9L58.82,10.451l-15.7-7.282Z",
    transform: "translate(-2.207 1.676)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 0.538,
    cy: 0.687,
    rx: 0.538,
    ry: 0.687,
    transform: "translate(15.916 9.342) rotate(-66.153)",
    fill: "#fff",
    opacity: 0.83
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGold1);
export default __webpack_public_path__ + "static/media/star-gold-1.ed2a244cb7bb269ede3fe70ab91cdb93.svg";
export { ForwardRef as ReactComponent };